<template>
  <div class="pointWap">
    <div class="headerCard">
      <div class="pointTitleBox line_bottom">
        <div class="pointNum">
          <span>{{scoreDetail.score === null ? '' : scoreDetail.score === undefined ? '' : '-' + scoreDetail.score}}</span>
          <span>分</span>
        </div>
        <div
          class="pointType"
          :class="{'pointTypeColor': scoreDetail.stateName == '已下线'}"
        >{{scoreDetail.stateName || ''}}</div>
      </div>
      <!-- 下线状态 -->
      <div class="insertTypeBox" v-if="scoreDetail.status === 2? true : false">
        <div class="insertType">
          <div class="title">下线原因</div>
          <div class="reason">{{scoreDetail.revocationReasonName || '无资料'}}</div>
        </div>
        <div class="insertType insertTypes flex-cloum">
          <div class="title">下线说明</div>
          <div class="reason">{{scoreDetail.cancelRemark || '无资料'}}</div>
        </div>
        <div class="insertType insertTypes" v-if="scoreDetail && scoreDetail.cancelAttachUrlList && scoreDetail.cancelAttachUrlList.length > 0">
          <div class="title addtitle">补充附件</div>
          <div
            class="insertReplenish"
          >
            <better-scroll class="imgList" :scrollX="true">
              <div class="warp">
                <img
                  :src="value"
                  @click="showViewer(index, $event, cancelAttachList)"
                  v-for="(value, index) in cancelAttachList"
                  :key="index"
                />
              </div>
            </better-scroll>
          </div>
          <!-- <div class="reason" v-else>无附件</div> -->
        </div>
        <div class="insertType">
          <div class="title">操作人</div>
          <div class="reason">{{scoreDetail.cancelName}}</div>
        </div>
        <div class="insertType">
          <div class="title">下线时间</div>
          <div class="reason">{{scoreDetail.cancelTime | filtTime}}</div>
        </div>
      </div>
      <!-- 扣分说明 -->
      <div class="pointTitle" v-else>
        <div class="pointState">扣分说明</div>
        <div class="pointDay">
          <div class="pointBox">
            <div class="title">扣分日期</div>
            <div class="day" v-show='createTime'>{{createTime | filtTime}}</div>
          </div>
          <div class="pointBox">
            <div class="title">扣分原因</div>
            <div class="day">{{scoreDetail.groupName || '无资料'}}</div>
          </div>
          <div class="pointBox">
            <div class="title">详细类型</div>
            <div class="day">{{scoreDetail.detailName || '无资料'}}</div>
          </div>
          <div class="pointBox">
            <div class="title">扣分人</div>
            <div class="day">{{scoreDetail.creatorName || '无资料'}}</div>
          </div>
          <div class="pointBox" v-if="scoreDetail.stateName != '已下线'">
            <div class="title">剩余有效期</div>
            <div class="day">{{scoreDetail.differenceStr || '无资料'}}</div>
          </div>
        </div>
      </div>

      <div class="insertingBox line_top" v-show="scoreDetail.status === 0" @click="handleToReferralPoints">
        <div class="insert">下线该扣分</div>
        <div class="insert_img">
          <img src="../../../../assets/integrity/ic_xl@3x.png" alt="">
        </div>
      </div>
    </div>
    <div class="markCard" v-if="scoreDetail.status === 2? true : false">
      <!-- 扣分说明 -->
      <div class="pointTitle">
        <div class="pointState">扣分说明</div>
        <div class="pointDay">
          <div class="pointBox">
            <div class="title">扣分日期</div>
            <div class="day" v-show='createTime'>{{createTime | filtTime}}</div>
          </div>
          <div class="pointBox">
            <div class="title">扣分原因</div>
            <div class="day">{{scoreDetail.groupName || '无资料'}}</div>
          </div>
          <div class="pointBox">
            <div class="title">详细类型</div>
            <div class="day">{{scoreDetail.detailName || '无资料'}}</div>
          </div>
          <div class="pointBox">
            <div class="title">扣分人</div>
            <div class="day">{{scoreDetail.creatorName || '无资料'}}</div>
          </div>
          <div class="pointBox" v-if="scoreDetail.stateName != '已下线'">
            <div class="title">剩余有效期</div>
            <div class="day">{{scoreDetail.differenceStr || '无资料'}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="conditionBox">
      <div class="conditionTitle">违规情况</div>
      <div class="conditionList">
        <div class="conditionItem">
          <div class="title">违法违规日期</div>
          <div class="explain">{{illegalDate | filtDate}}</div>
        </div>
        <div class="conditionItem_child">
          <div class="title">违规详细说明</div>
          <div class="explain">{{scoreDetail.remark || '无资料'}}</div>
        </div>
        <!-- <div class="conditionItem conditionItems" v-if="scoreDetail.attachUrlList && scoreDetail.attachUrlList.length !== 0">
          <div class="replenishTitle">补充附件</div>
          <better-scroll class="imgList" :scrollX="true">
            <div class="warp">
              <img
                :src="value"
                @click="showViewer(index, $event, attachList)"
                v-for="(value, index) in attachList"
                :key="index"
              />
            </div>
          </better-scroll>
        </div> -->
        <div class="file_img" v-if="scoreDetail.attachUrlList && scoreDetail.attachUrlList.length !== 0">
             <p class="text">补充附件</p>
             <better-scroll class="file_item" :scrollX="true">
              <div class="file_wrapper">
                  <img
                      :src="value"
                      @click="showViewer(index, $event, attachList)"
                      v-for="(value, index) in attachList"
                      :key="index"
                    />
              </div>
        </better-scroll>
        </div>
        
      </div>
    </div>
    <transition name="fade">
      <div
        class="examineDetailTipsBox"
        transition="fade"
        v-show="examineDetailTips"
        @click="handleTest"
      >
        <img src="../../../../assets/image/icon_ts_tg.png" v-if="tipsIcon" />
        <img src="../../../../assets/image/icon_ts_gx.png" v-if="!tipsIcon" />
        <p>{{tipsMsg}}</p>
      </div>
    </transition>
  </div>
</template>

<script>
    import betterScroll from '../../../../components/base/betterScroll';
    import api from '../../../../service/modules/integrity';
    export default {
        components: {
            'better-scroll': betterScroll
        },
        data () {
            return {
                isShow: true,
                // 企业规范指数扣分列表
                scoreDetail: {},
                commonPath:
                    'https://t-tio.ybsjyyn.com/gov/tio/integrity/attach/getAttach?cosKey=',
                cancelAttachList: [], // 下线扣分附件
                attachList: [], // 违规扣分附件
                // cancelAttach: [
                //     // 'https://img.yzcdn.cn/vant/cat.jpeg'
                // ],
                enterpriseGradeId: '', // 扣分详情ID
                enterpriseId: '', // 企业ID
                // 提交按钮提交完的tip状态
                examineDetailTips: false,
                tipsIcon: true,
                tipsMsg: '',
                isBlackList: false, // 判断石否是黑名单
                createTime: '0', // 扣分日期
                illegalDate: '0' // 违规日期
            };
        },
        created () {
            this.isNeedTips();
            this.enterpriseId = this.$route.query.enterpriseId; // 企业ID
            this.enterpriseGradeId =
                this.$route.query.id || localStorage.getItem('enterpriseGradeId'); // 扣分详情ID
            this.saveId();
            // 获取详情
            this.getDeductDetail();
        },
        methods: {
            // 缓存enterpriseGradeId
            saveId () {
                if (this.$route.query.id === undefined) {
                } else {
                    localStorage.setItem('enterpriseGradeId', this.$route.query.id);
                }
            },
            // 点击取消弹窗
            handleTest () {
                this.examineDetailTips = false;
            },
            // 弹窗事件
            isShowTipsBox () {
                this.examineDetailTips = true;
                let t = setTimeout(() => {
                    this.examineDetailTips = false;
                    clearTimeout(t);
                }, 2000);
            },
            // 判断是否需要弹窗
            isNeedTips () {
                let state = JSON.parse(localStorage.getItem('referraState'));
                if (state && state.success) {
                    this.tipsMsg = state.msg;
                    this.isShowTipsBox();
                }
                localStorage.removeItem('referraState');
            },
            // 图片预览
            showViewer (index, event, imgList) {
                // this.$ImagePreview({ images: imgList, startPosition: index, closeOnPopstate: true });
                this.$router.push({
                  path: '/complaint/imagesView',
                  query: {
                    imageList:imgList|| [],
                    index
                  },
                })

            },
            // 跳转到下线扣分页面
            handleToReferralPoints () {
                if (this.isBlackList === false) {
                    let params = {
                        // scoreDetail: this.scoreDetail,
                        enterpriseId: this.enterpriseId, // 企业ID
                        deductId: this.scoreDetail.id
                    };
                    this.$router.push({ name: 'referralPoints', params: params });
                    // this.$router.replace({ name: 'referralPoints', params: params });
                } else {
                    this.$Toast({
                        message: '企业已纳入黑名单，无法下线该扣分',
                        forbidClick: true
                    })
                }
            },
            // 获取企业规范指数扣分列表
            getDeductDetail () {
                let data = {
                    deductId: this.enterpriseGradeId
                };
                api.deductDetail(data).then(res => {
                    if (res.ret === 0) {
                        let data = res.data;
                        this.scoreDetail = data;
                        this.createTime = data.createTime; // 扣分日期
                        this.illegalDate = data.illegalDate; // 违规日期
                        this.isBlackList = data.isBlackList;
                        if (data && data.attachUrlList) {
                            this.attachList = data.attachUrlList;
                        }
                        if (data && data.cancelAttachUrlList) {
                            this.cancelAttachList = data.cancelAttachUrlList;
                        }
                    }
                });
            }
        },
        // 时间搓
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D + h + m + s;
                return strDate;
            },
            filtDate (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D;
                return strDate;
            }
        }
    };
</script>

<style lang="less" scoped>
.pointWap {
  width: 100%;
  min-height: 100vh;
  padding: 20px 12px;
  background: #fafafa;
  .headerCard {
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    .pointTitleBox {
      height: 88px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-attachment: fixed;
      .pointNum {
        span:nth-child(1) {
          font-size: 20px;
          color: #333333;
          font-weight: bold;
        }
        span:nth-child(2) {
          font-size: 10px;
          color: #333333;
          margin-left: 4px;
        }
      }
      .pointType {
        margin-top:8px;
        color: #36b374;
        font-size: 12px;
      }
      .pointTypeColor {
        color: #999999;
        font-size: 12px;
        margin-top:8px;
      }
    }
    .insertTypeBox {
      padding: 16px;
      .addtitle{
        margin-bottom: 10px;
      }
      .insertType {
        display: flex;
        margin-top: 12px;
        .title {
          width: 60px;
          color: #999;
          font-size: 14px;
          line-height: 18px;
        }
        .reason {
          line-height: 18px;
          color: #333333;
          font-size: 14px;
          margin-left: 16px;
          word-break: break-all;
        }
        .insertReplenish {
          .imgList {
            width: 100%;
            height: 74px;
            overflow: hidden;
            position: relative;
            .warp {
              white-space: nowrap;
              position: absolute;
              img {
                width: 74px;
                height: 74px;
                display: inline-block;
                margin-right: 8px;
                border-radius: 3px;
              }
            }
          }
        }
      }
      .insertType:first-child{
        margin-top: 0px;
      }
      .flex-cloum {
        flex-direction: row !important;
        .title {
          width: 60px;
        }
        .reason {
          margin-left: 16px !important;
          flex: 1;
        }
      }
      .insertTypes {
        display: flex;
        flex-direction: column;
        .reason {
          margin-left: 0px;
        }
      }
    }
     .pointTitle {
      padding: 16px 20px;
      .pointState {
        font-size: 14px;
        color: #333333;
        font-weight: bold;
      }
      .pointDay {
        .pointBox {
          margin-top: 12px;
          display: flex;
          .title {
            width: 97px;
            color: #999;
            font-size: 14px;
            line-height: 18px;
          }
          .day {
            line-height: 18px;
            color: #333333;
            font-size: 14px;
            width: 100%;
            margin-left: 16px;
          }
        }
      }
    }
    .insertingBox {
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      .insert {
        color:#36b374;
        font-size: 14px;
      }
      .insert_img {
        display: flex;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
  .markCard {
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    margin-top: 12px;
    .pointTitle {
      padding: 16px 20px;
      .pointState {
        font-size: 14px;
        color: #333333;
        font-weight: bold;
      }
      .pointDay {
        .pointBox {
          margin-top: 12px;
          display: flex;
          .title {
            width: 96px;
            color: #999;
            font-size: 14px;
            line-height: 18px;
          }
          .day {
            line-height: 18px;
            color: #333333;
            font-size: 14px;
            width: 100%;
            margin-left: 16px;
          }
        }
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .examineDetailTipsBox {
    width: 120px;
    height: 124px;
    padding: 24px 0 0 0;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    > img {
      width: 50px;
      height: 50px;
      margin: 0 auto 12px;
      display: block;
    }

    > p {
      text-align: center;
      color: #fff;
    }
  }

  .conditionBox {
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    margin-top: 12px;
    padding: 16px;
    .conditionTitle {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }
    .conditionList {
      margin-top: 16px;
      .conditionItem {
        margin-top: 12px;
        display: flex;
        .imgList {
          width: 100%;
          height: 74px;
          overflow: hidden;
          position: relative;
          margin-top: 8px;
          .warp {
            white-space: nowrap;
            position: absolute;
            img {
              width: 74px;
              height: 74px;
              display: inline-block;
              margin-right: 8px;
              border-radius: 3px;
            }
          }
        }
        .title {
          color: #999;
          font-size: 14px;
          line-height: 18px;
        }
        .explain {
          line-height: 18px;
          font-size: 14px;
          color: #333333;
          margin-left: 16px;
        }
        .replenishTitle {
          width: 110px;
          color: #999;
          font-size: 14px;
          float: left;
        }
        .replenish {
          margin-top: 20px;
          width: 100%;
          .imgBox {
            float: left;
            width: 30%;
            margin: 0 6px 4px 0;
            overflow: hidden;
            img {
              display: inline-block;
            }
          }
        }
      }
      .conditionItems {
        flex-direction: column;
      }
      .conditionItem_child {
        margin-top: 12px;
        display: flex;
        align-items: flex-start;
        .title {
          width: 85px;
          color: #999;
          font-size: 14px;
          line-height: 24px;
        }
        .explain {
          line-height: 24px;
          font-size: 14px;
          color: #333333;
          margin-left: 15px;
          word-break: break-all;
          flex: 1;
        }
        .replenishTitle {
          width: 110px;
          color: #999;
          font-size: 14px;
          float: left;
        }
        .replenish {
          margin-top: 20px;
          width: 100%;
          .imgBox {
            float: left;
            width: 30%;
            margin: 0 6px 4px 0;
            overflow: hidden;
            img {
              display: inline-block;
            }
          }
        }
      }
      .file_img{
        width:100%;
        .text{
          color: #999;
          font-size: 14px;
          margin-top:12px;
        }
        .file_item{
          width:100%;
          height:74px;
          position: relative;
          overflow: hidden;
          margin-top:12px;
          .file_wrapper{
            white-space: nowrap;
            height:74px;
            position: absolute;
              img{
                width: 74px;
                height: 74px;
                display: inline-block;
                margin-right: 8px;
                border-radius: 3px;
              }
              
          }
        }
      }
      
    }
    .imgList {
      width: 100%;
      height: 80px;
      overflow: hidden;
      position: relative;
      .warp {
        white-space: nowrap;
        position: absolute;
        img {
          width: 80px;
          height: 80px;
          display: inline-block;
          margin-right: 10px;
        }
      }
    }
  }

}
</style>
